// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7670":"css/app.6918","8693":"css/admin-app.6918"}[chunkId] + ".css";
};